import { ModuleWithProviders, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HeaderComponent } from './components/header/header.component';
import { MobileNavComponent } from './components/mobile-nav/mobile-nav.component';
import { SideNavComponent } from './components/side-nav/side-nav.component';
import { LayoutComponent } from './components/layout/layout.component';
import { LayoutConfig } from './models/layout.config';
import { LAYOUT_CONFIG_TOKEN } from './services/layout.token';
import { RouterModule } from '@angular/router';
import { FooterComponent } from './components/footer/footer.component';
import { HttpProgressIndicatorComponent, AvatarComponent } from '@seech/ux-ng';
import { PlaceholderComponent } from '@seech/ux-ng';
import { IconDirective, IconsNgModule } from '@seech/icons-ng';
import { CdkMenuModule } from '@angular/cdk/menu';
import { MobileFooterComponent } from './components/mobile-footer/mobile-footer.component';
import { ScopeSwitcherComponent } from './components/scope-switcher/scope-switcher.component';
import { ControlsNgModule } from '@seech/controls-ng';
import { ImageComponent } from '@seech/media-ng';

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    PlaceholderComponent,
    HttpProgressIndicatorComponent,
    AvatarComponent,
    ImageComponent,
    IconDirective,
    IconsNgModule,
    CdkMenuModule,
    ControlsNgModule
  ],
  declarations: [
    HeaderComponent,
    MobileNavComponent,
    SideNavComponent,
    LayoutComponent,
    FooterComponent,
    MobileFooterComponent,
    ScopeSwitcherComponent,
  ],
  exports: [
    LayoutComponent,
    HeaderComponent,
    MobileNavComponent,
    SideNavComponent,
    FooterComponent,
    MobileFooterComponent,
    ScopeSwitcherComponent,
  ],
})
export class LayoutNgModule {
  public static forRoot(
    config: LayoutConfig
  ): ModuleWithProviders<LayoutNgModule> {
    return {
      ngModule: LayoutNgModule,
      providers: [{ provide: LAYOUT_CONFIG_TOKEN, useValue: config }],
    };
  }
}
